import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const Type = ({ segment }: SpecProps<"segment">) => {
  const { i18n } = useLingui();

  if (!segment) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.mobileHome.type",
    message: "Type of mobile home",
    comment: "Field for 'Type of mobile-home' in ad specification",
  });

  return <FieldValuePair field={field} value={segment} />;
};
